import React from 'react'

import './style.scss'

const img1 = require('../../assets/images/preloader/01-min.png')
const img2 = require('../../assets/images/preloader/02-min.png')
const img3 = require('../../assets/images/preloader/03-min.png')
const img4 = require('../../assets/images/preloader/04-min.png')
const img5 = require('../../assets/images/preloader/05-min.png')
const img6 = require('../../assets/images/preloader/06-min.png')
const img7 = require('../../assets/images/preloader/07-min.png')
const img8 = require('../../assets/images/preloader/08-min.png')
const img9 = require('../../assets/images/preloader/09-min.png')

const preloadImages = {
  i1: img1,
  i2: img2,
  i3: img3,
  i4: img4,
  i5: img5,
  i6: img6,
  i7: img7,
  i8: img8,
  i9: img9,
}

class Preloader extends React.Component {
  state = {
    count: 0,
    delay: 250,
    img: preloadImages['i1']
  }

  componentDidMount() {
    this.counterImages = 0
    this.temporaryImages = document.querySelector('.temporary-images')
    this.images = this.temporaryImages.querySelectorAll('img')

    let counter = 0
    this.interval = setInterval(() => {
      if (counter === 9) {
        counter = 0
      }

      counter += 1

      this.setState({
        img: preloadImages['i' + counter]
      })
    }, this.state.delay)

    this.loadedAllImages()
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.delay !== this.state.delay) {
      clearInterval(this.interval)
      this.interval = setInterval(this.changeImage, this.state.delay)
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval)
  }

  changeImage = () => {
    this.setState({
      count: this.state.count + 1
    })
  }

  loadedAllImages() {
    for (let i = 0; i < this.images.length; i++) {
      if (this.images[i].complete) {
        this.incrementCounter()
      } else {
        this.images[i].addEventListener('load', () => this.incrementCounter(), false)
      }
    }
  }

  incrementCounter() {
    this.counterImages++
    if (this.counterImages === this.images.length) {
      setTimeout(() => {
        this.props.pageLoaded()
      }, 4000)
    }
  }

  render() {
    return (
      <div className="preloader">
        <img alt="" src={this.state.img}/>
      </div>
    )
  }
}

export default Preloader
